import { PropsWithChildren, ReactNode } from "react";
import clsx from "clsx";

import { Separator } from "./Separator";

export function PageTitle({
  children,
  subtitle,
  ...props
}: PropsWithChildren<{ subtitle?: ReactNode }>) {
  return (
    <div
      {...props}
      className={clsx("flex flex-col items-center", "mb-md gap-sm md:mb-xl")}
      data-component="PageTitle"
    >
      <h1 className="text-center text-2xl font-bold">{children}</h1>
      <div className="w-[64px]">
        <Separator />
      </div>
      {subtitle && (
        <p className="whitespace-break-spaces text-center text-sm" data-component="Subtitle">
          {subtitle}
        </p>
      )}
    </div>
  );
}
